import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const ProjectDetailsPageContent = lazy(() => import("./ProjectDetailsPageContent"));

function ProjectDetailsPageInternal() {
    return (
        <DefaultPage>
            <ProjectDetailsPageContent />
        </DefaultPage>
    );
}

export const ProjectDetailsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    ProjectDetailsPageInternal
);
